export default {
  "slots": {
    "root": "w-full space-y-6",
    "header": "flex flex-col text-center",
    "leading": "mb-2",
    "leadingIcon": "size-8 shrink-0",
    "title": "text-xl text-pretty font-semibold text-(--ui-text-highlighted)",
    "description": "mt-1 text-base text-pretty text-(--ui-text-muted)",
    "body": "gap-y-6 flex flex-col",
    "providers": "space-y-3",
    "separator": "",
    "form": "space-y-5",
    "footer": "text-sm text-center text-(--ui-text-muted) mt-2"
  }
}